import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useReverseAddress, type DeliveryAddress } from './api'
import type { MapPoint } from './AddressMap'

/**
 * Что покупатель уже указал: адрес из поиска или списка — готовый, точка с
 * карты ждёт подписи геокодера. Состояние живёт у экрана, а не в поиске:
 * адрес оформления выбирают ещё и из сохранённых.
 */
export function useAddressDraft(initial: DeliveryAddress | null) {
  const { i18n } = useTranslation()
  const [picked, setPicked] = useState<DeliveryAddress | null>(initial)
  const [spot, setSpot] = useState<MapPoint | null>(null)
  const [query, setQuery] = useState('')
  const reverse = useReverseAddress(spot, i18n.language)

  const selected: DeliveryAddress | null = spot
    ? reverse.data
      ? { label: reverse.data, ...spot }
      : null
    : picked

  function take(address: DeliveryAddress) {
    setPicked(address)
    setSpot(null)
    setQuery('')
  }

  return { picked, spot, setSpot, query, setQuery, reverse, selected, take }
}

export type AddressDraft = ReturnType<typeof useAddressDraft>
